module.exports = __webpack_public_path__ + "assets/682cfd9526693fb9f513808ebc0a3784.png";